<template>
    <div>
        <environment-banner></environment-banner>
        <notifications class="max-w-md select-none relative z-[12000]" position="bottom right" width="100%" :duration="3500">
            <template #body="props">
                <div class="inset-0 flex items-end justify-center pointer-events-none sm:items-start sm:justify-end">
                    <div class="w-full mx-4 mb-4 bg-white rounded-sm pointer-events-auto">
                        <div class="rounded-sm shadow-md border border-gray-200 overflow-hidden">
                            <div class="p-4" @click="props.close">
                                <div class="flex items-start">
                                    <div class="flex-shrink-0">
                                        <svg-vue v-if="props.item.type === 'error'" class="h-6 w-6 text-red-400" icon="font-awesome.times-circle-light"></svg-vue>
                                        <svg-vue v-else-if="props.item.type === 'warning'" class="h-6 w-6 text-orange-400" icon="font-awesome.exclamation-triangle-light"></svg-vue>
                                        <svg-vue v-else-if="props.item.type === 'info'" class="h-6 w-6 text-gray-400" icon="font-awesome.regular.circle-info"></svg-vue>
                                        <svg-vue v-else class="h-6 w-6 text-green-400" icon="font-awesome.check-circle-light"></svg-vue>
                                    </div>
                                    <div class="ml-3 w-0 flex-1 pt-0.5">
                                        <p class="text-sm leading-5 font-medium text-gray-900">
                                            {{ props.item.title }}
                                        </p>
                                        <p class="mt-1 text-sm leading-5 text-gray-500" v-html="props.item.text"/>
                                    </div>
                                    <div class="ml-4 flex-shrink-0 flex">
                                        <button class="notification-close-btn" type="button" @click="props.close">
                                            <svg-vue class="h-4 w-4" icon="font-awesome.times-light"></svg-vue>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </notifications>
        <router-view/>
    </div>
</template>

<script>
import EnvironmentBanner from "@/components/layout/shared/environment-banner";

export default {
    name: "App",
    components: {EnvironmentBanner},
}
</script>

<style lang="scss">
.vue-notification-group {
    z-index: 12000 !important;
}

.notification-close-btn {
    color: var(--ui-text-subtle);
    background: transparent;
    border: 0;
    padding: 0.25rem;
    line-height: 1;
    border-radius: 0.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.notification-close-btn:hover {
    color: var(--ui-text-muted);
}
</style>
